import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-add-dialog-produit',
    templateUrl: './add-dialog-produit.component.html',
    styleUrls: ['./add-dialog-produit.component.css'],
})
export class AddDialogProduitComponent implements OnInit {
    idfils1: any;
    idfils2: any;
    idfils3: any;
    form = new FormGroup({
        cateId: new FormControl({value: null, disabled: true}, [
            Validators.required,
        ]),
        makeFl: new FormControl(null, [Validators.required]),
        name: new FormControl({value: null, disabled: true}, [
            Validators.required,
        ]),

        root: new FormControl(null, [Validators.required]),
        fils1: new FormControl({value: null, disabled: true}, [
            Validators.required,
        ]),
        fils2: new FormControl({value: null, disabled: true}, [
            Validators.required,
        ]),
        fils3: new FormControl({value: null, disabled: true}, [
            Validators.required,
        ]),
    });

    constructor(
        private dialog: MatDialogRef<AddDialogProduitComponent, { data: any }>
    ) {
    }

    getFormControl(key: string): FormControl {
        return this.form.controls[key] as FormControl;
    }

    ngOnInit(): void {
    }

    onSuccessAdd() {
        if (this.form.valid) {
            const data = this.form.getRawValue();

            this.dialog.close({
                data: data,
            });
        }
    }

    send(value) {
        this.idfils1 = value.cateId;
        this.form.controls['fils1'].enable();
    }

    sendfils(value: any) {
        this.idfils2 = value.cateId;
        this.form.controls['fils2'].enable();
    }

    sendfils2(value: any) {
        this.idfils3 = value.cateId;
        this.form.controls['fils3'].enable();
    }

    sendfils3(value: any) {

        this.form.get('cateId').setValue(value.cateId);
        this.form.get('name').setValue(value.cateNm);
    }
}
